package com.example.readingnotes.data.remote.dto

import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class NotificationDto(
    val id: Int,
    val type: String,
    val title: String,
    val body: String,
    val data: String? = null,
    @SerialName("isRead")
    val isRead: Boolean,
    @SerialName("relatedPostId")
    val relatedPostId: Int? = null,
    @SerialName("relatedCommentId")
    val relatedCommentId: Int? = null,
    @SerialName("createdAt")
    val createdAt: String,
    @SerialName("readAt")
    val readAt: String? = null,
)

@Serializable
data class NotificationSettingsDto(
    @SerialName("enableNewPost")
    val enableNewPost: Boolean,
    @SerialName("enableNewComment")
    val enableNewComment: Boolean,
    @SerialName("enableCommentReply")
    val enableCommentReply: Boolean,
    @SerialName("enableMention")
    val enableMention: Boolean,
    @SerialName("enableSystem")
    val enableSystem: Boolean,
    @SerialName("muteStart")
    val muteStart: String? = null,
    @SerialName("muteEnd")
    val muteEnd: String? = null,
)

@Serializable
data class NotificationsResponseDto(
    val notifications: List<NotificationDto>,
    val total: Int,
    val limit: Int,
    val offset: Int,
)

@Serializable
data class UpdateNotificationSettingsRequestDto(
    @SerialName("enableNewPost")
    val enableNewPost: Boolean,
    @SerialName("enableNewComment")
    val enableNewComment: Boolean,
    @SerialName("enableCommentReply")
    val enableCommentReply: Boolean,
    @SerialName("enableMention")
    val enableMention: Boolean,
    @SerialName("enableSystem")
    val enableSystem: Boolean,
    @SerialName("muteStart")
    val muteStart: String? = null,
    @SerialName("muteEnd")
    val muteEnd: String? = null,
)

@Serializable
data class MarkAsReadResponseDto(
    val success: Boolean,
)

@Serializable
data class MarkAllAsReadResponseDto(
    val success: Boolean,
    val count: Int,
)
